import { AxiosResponse } from "axios";
import * as API from "middleware/api";
import { PickerFileRequestType } from "pages/detailPicker/types";
import {
  AccountTypesApiResponseContentType,
  BankResponseType,
  BankType,
  DetailPickersIdentificationTypeApiResponseType,
  DetailPickersProvincesApiResponseType,
  ExpandableFileLoadParamType,
} from "sagas/types/pickers";
import {
  PickerType,
  EditPickerResponseType,
  ParamsMiddlewareType,
  PickersAxiosResponseType,
  PickersExportResponseType,
  PickerFileResponseType,
  PickerAccountDataFilesType,
} from "../pages/pickers/types";
import { PICKER_ACCOUNT_DATA_FILES_TYPE } from "utils/constants";

export const getPickers = (
  params: ParamsMiddlewareType
): Promise<AxiosResponse<PickersAxiosResponseType>> =>
  API.get("/ms-admin-rest/api/v1.0/pickers", params);

export const getPickersExport = (
  params: ParamsMiddlewareType
): Promise<AxiosResponse<PickersExportResponseType>> => {
  const { limit, offset, ...body } = params;
  return API.get("/ms-admin-rest/api/v1.0/pickers.csv", body);
};

export const getPicker = (params: number): Promise<AxiosResponse<PickerType>> =>
  API.get(`/ms-admin-rest/api/v1.0/pickers/${params}`);

export const postPickerDocumentsEdit = (
  params: PickerType
): Promise<AxiosResponse<EditPickerResponseType>> =>
  API.post(
    `/ms-admin-rest/api/v1.0/pickers/${params.id}/invalid-documentation`,
    params
  );

export const postEditPicker = (
  params: PickerType
): Promise<AxiosResponse<EditPickerResponseType>> =>
  API.post(`/ms-admin-rest/api/v1.0/pickers/${params.id}`, params);

export const postAprovePicker = (
  params: PickerType
): Promise<AxiosResponse<EditPickerResponseType>> =>
  API.post(`/ms-admin-rest/api/v1.0/pickers/${params.id}/approve`, params);

export const fileUpload = (
  id: number,
  params: ExpandableFileLoadParamType
): Promise<AxiosResponse<void>> =>
  API.put(
    `/ms-admin-rest/api/v1.0/pickers/${id}/${
      PICKER_ACCOUNT_DATA_FILES_TYPE.includes(
        params.tag as PickerAccountDataFilesType
      )
        ? "fiscal-files"
        : "files"
    }`,
    params
  );

export const getFile = ({
  id,
  tag,
}: PickerFileRequestType): Promise<AxiosResponse<PickerFileResponseType>> =>
  API.get(
    `/ms-admin-rest/api/v1.0/pickers/${id}/${
      PICKER_ACCOUNT_DATA_FILES_TYPE.includes(tag as PickerAccountDataFilesType)
        ? "fiscal-files"
        : "files"
    }/${tag}`
  );

export const deleteFile = (
  id: number,
  tag: string
): Promise<AxiosResponse<void>> =>
  API.remove(
    `/ms-admin-rest/api/v1.0/pickers/${id}/${
      PICKER_ACCOUNT_DATA_FILES_TYPE.includes(tag as PickerAccountDataFilesType)
        ? "fiscal-files"
        : "files"
    }/${tag}`
  );

export const getBankName = (
  cbuPrefix?: string
): Promise<AxiosResponse<API.ApiResponseResult<BankType>>> => {
  return API.get(`/ms-admin-rest/api/v1.0/banks/${cbuPrefix}`);
};
export const getBanks = (): Promise<
  AxiosResponse<API.ApiResponse<BankResponseType>>
> => {
  return API.get(`/ms-admin-rest/api/v1.0/banks`);
};
export const getProvinces = (): Promise<
  AxiosResponse<DetailPickersProvincesApiResponseType>
> => API.get(`/ms-admin-rest/api/v1.0/provinces`);

export const getAccountType = (): Promise<
  AxiosResponse<API.ApiResponse<AccountTypesApiResponseContentType>>
> => API.get(`/ms-admin-rest/api/v1.0/fiscal-data/account-types`);
export const getIdentificationType = (): Promise<
  AxiosResponse<DetailPickersIdentificationTypeApiResponseType>
> => API.get(`/ms-admin-rest/api/v1.0/users/identifications`);
